import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const ExternalLink = ({ href, className, children }) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
  >
    <Label>{children}</Label>
    <ExternalIcon icon={faExternalLinkAlt} />
  </Link>
);

const Link = styled.a`
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  color: var(--green);
`;

const ExternalIcon = styled(FontAwesomeIcon)`
  margin-left: 8px;
`;

const Label = styled.div`
  font-weight: 600;
`;

export default ExternalLink;
